import script from "./DueDiligenceDocs.vue?vue&type=script&setup=true&lang=js"
export * from "./DueDiligenceDocs.vue?vue&type=script&setup=true&lang=js"

import "./DueDiligenceDocs.vue?vue&type=style&index=0&id=83e7ea12&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83e7ea12"]])

export default __exports__